import { render, staticRenderFns } from "./MaintenanceScreen.vue?vue&type=template&id=ca1ffc80&scoped=true"
import script from "./MaintenanceScreen.vue?vue&type=script&lang=js"
export * from "./MaintenanceScreen.vue?vue&type=script&lang=js"
import style0 from "./MaintenanceScreen.vue?vue&type=style&index=0&id=ca1ffc80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1ffc80",
  null
  
)

export default component.exports